/* eslint-disable @typescript-eslint/naming-convention */
import { type CSSObject, Stack, Typography, styled } from '@mui/material';
import { Section } from '@rumblefish/ui/Rumblefish23Theme';
export const StyledSection = styled(Section)(() => ({
  position: 'relative',
}));
export const StyledStack = styled(Stack)(({ theme }) => ({
  paddingBottom: theme.spacing(11),
  marginTop: theme.spacing(0),
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  alignItems: 'center',
  gap: theme.spacing(6),
  [theme.breakpoints.down('md')]: {
    marginTop: theme.spacing(6),
    gap: theme.spacing(4),
  },
  [theme.breakpoints.down('sm')]: {
    marginTop: theme.spacing(4),
  },
}));

export const StyledHeadline = styled(Typography)(({ theme }) => ({
  ...(theme.mixins.neutralGradient as CSSObject),
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
}));
export const SectionNameBannerStack = styled(Stack)(({ theme }) => ({
  width: '100%',

  [theme.breakpoints.up('md')]: {
    position: 'absolute',
    top: 0,
    left: 0,
  },
}));
export const StyledServicesWrapper = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  border: `1px solid ${theme.palette.greyBackgroundColor?.SURFACE + '10'}`,
  borderRadius: theme.spacing(4),
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
}));
export const SingleServiceWrapper = styled(Stack)(({ theme }) => ({
  flex: 1,
  gap: theme.spacing(2),
  borderRight: `1px solid ${theme.palette.greyBackgroundColor?.SURFACE + '10'}`,
  '&:last-child': {
    borderRight: '0px !important',
  },
  padding: `${theme.utils.fluidSize({
    minSize: 18,
    maxSize: 48,
    minBp: 960,
  })}`,
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(3),
    borderRight: '0px',
  },
  [theme.breakpoints.up('xl')]: {
    padding: theme.spacing(6),
  },
}));
export const BubbleWrapper = styled(Stack)(({ theme }) => ({
  position: 'relative',
  aspectRatio: '1 / 1',

  marginBottom: theme.spacing(2),
  width: `${theme.utils.fluidSize({
    minSize: 100,
    maxSize: 110,
    minBp: 960,
  })}`,
  [theme.breakpoints.down('lg')]: {
    marginBottom: theme.spacing(1),
  },
  [theme.breakpoints.down('md')]: {
    width: '100px',
  },
  [theme.breakpoints.up('xl')]: {
    width: '110px',
  },
}));
export const StyledServiceHedline = styled(Typography)(({ theme }) => ({
  color: theme.palette.invertedContent?.PRIMARY,
}));
export const StyledServiceDescription = styled(Typography)(({ theme }) => ({
  color: theme.palette.invertedContent?.SECONDARY,
}));
